
export default {
  name: 'ImageTextBlock',
  props: {
    mobileImage: {
      type: Object,
      required: false,
      default: () => ({})
    },
    desktopImage: {
      type: Object,
      required: false,
      default: () => ({})
    },
    headline: {
      type: String,
      required: false,
      default: ''
    },
    text: {
      type: Object,
      required: false,
      default: () => ({})
    },
    linkText: {
      type: String,
      required: false,
      default: ''
    },
    link: {
      type: Object,
      required: false,
      default: () => ({})
    },
    backgroundColor: {
      type: String,
      required: false,
      default: '#E7E5DF'
    },
    textColor: {
      type: String,
      required: false,
      default: '#383838'
    },
    textPosition: {
      type: String,
      required: false,
      default: 'right'
    }
  },
  data () {
    return {
      emptyLink: {
        url: '',
        linktype: 'story',
        fieldtype: 'multilink'
      }
    }
  }
}
